/*
  Cecil & Lou — floating "Filter" pill for collection pages.

  With Globo infinite scroll the real filter controls live only at the top of
  the page, so on long collections shoppers must scroll all the way back up to
  filter. This adds a small pink pill fixed to the BOTTOM-LEFT corner (opposite
  the chat bubble, never overlapping the header). It fades in once you scroll
  past the real toolbar and opens Globo's existing filter panel
  (.gf-filter-trigger) from anywhere on the page.

  It only shows while Globo's mobile "Filter By" toggle is visible — i.e. on
  mobile collection pages. On desktop (filters shown inline) and anywhere the
  toggle isn't present, the pill stays hidden.
*/
(function () {
  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    if (document.getElementById('cl-filter-pill')) return;

    var pill = document.createElement('button');
    pill.type = 'button';
    pill.id = 'cl-filter-pill';
    pill.setAttribute('aria-label', 'Open filters');
    pill.innerHTML =
      '<svg viewBox="0 0 24 24" width="22" height="22" fill="none" aria-hidden="true">' +
      '<path d="M4 6h13M4 12h9M4 18h5" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"/>' +
      '<circle cx="20" cy="6" r="2.2" fill="currentColor"/>' +
      '<circle cx="16" cy="12" r="2.2" fill="currentColor"/>' +
      '<circle cx="11" cy="18" r="2.2" fill="currentColor"/></svg>';

    // Matched to the Gorgias chat button's layered look: white base + its conic
    // ring + a pale-pink radial glow, with a #dd2276 icon and the same soft
    // shadow. bottom:27px keeps its center (52px above the bottom) aligned.
    pill.style.cssText = [
      'position:fixed',
      'left:16px',
      'bottom:27px',
      'z-index:40',
      'width:50px',
      'height:50px',
      'display:inline-flex',
      'align-items:center',
      'justify-content:center',
      'margin:0',
      'padding:0',
      'border:none',
      'border-radius:50%',
      'background:radial-gradient(circle, rgba(252,233,241,.6) 0%, rgba(252,233,241,0) 72%), conic-gradient(from 131deg, rgba(245,245,245,.6) 0deg, rgba(221,34,118,.1) 182.783deg, rgba(245,245,245,.6) 360deg), #ffffff',
      'color:#dd2276',
      'box-shadow:0 2px 4px rgba(22,22,22,.16)',
      'cursor:pointer',
      '-webkit-tap-highlight-color:transparent',
      'opacity:0',
      'transform:translateY(12px)',
      'pointer-events:none',
      'transition:opacity .2s ease, transform .2s ease',
    ].join(';');

    document.body.appendChild(pill);

    // Globo's real "Filter By" control is a <button> inside its mobile refine
    // toggle. Globo hides that toggle on desktop (filters show inline there), so
    // its visibility is our mobile + filter-available signal.
    function filterButton() {
      return (
        document.querySelector('.gf-refine-toggle-mobile button') ||
        document.querySelector('.gf-filter-trigger button') ||
        document.querySelector('button[aria-label="Filter By"]')
      );
    }

    function isVisible(el) {
      if (!el) return false;
      var cs = window.getComputedStyle(el);
      if (cs.display === 'none' || cs.visibility === 'hidden') return false;
      return el.getClientRects().length > 0;
    }

    pill.addEventListener('click', function () {
      // Clicking Globo's toggle opens the off-canvas filter drawer
      // (adds "offcanvas-open" to <html>).
      var btn = filterButton() || document.querySelector('.gf-filter-trigger');
      if (btn) {
        btn.click();
      } else {
        var fallback =
          document.querySelector('#main-collection-filters') ||
          document.querySelector('#ProductGridContainer');
        if (fallback) fallback.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });

    var shown = false;
    function update() {
      // Only when the mobile "Filter By" button is actually on screen, and once
      // scrolled past the real toolbar.
      var show = isVisible(filterButton()) && window.pageYOffset > 320;
      if (show === shown) return;
      shown = show;
      pill.style.opacity = show ? '1' : '0';
      pill.style.transform = show ? 'translateY(0)' : 'translateY(12px)';
      pill.style.pointerEvents = show ? 'auto' : 'none';
    }
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update, { passive: true });
    update();
  });
})();

/*
  Cecil & Lou — floating "Back to top" button (mobile + desktop).
  Appears once you've scrolled past the first page of products (where Globo's
  infinite scroll kicks in), pinned bottom-center — where it lines up in a row
  with the filter pill (bottom-left) and chat bubble (bottom-right) rather than
  crowding them. Hides again the moment the inline "Back to top" button at the
  very bottom of the grid comes into view, so the two never show at once.
*/
(function () {
  var FIRST_PAGE = 28; // products shown before infinite scroll begins

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    if (document.getElementById('cl-scrolltop')) return;

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.id = 'cl-scrolltop';
    btn.setAttribute('aria-label', 'Back to top');
    btn.innerHTML =
      '<svg viewBox="0 0 24 24" width="22" height="22" fill="none" aria-hidden="true">' +
      '<path d="M12 19V5M6 11l6-6 6 6" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    // Matched to the Gorgias chat button's layered look (see filter pill).
    // bottom:27px -> center 52px, aligned with the filter pill and chat.
    btn.style.cssText = [
      'position:fixed',
      'left:50%',
      'bottom:27px',
      'z-index:39',
      'width:50px',
      'height:50px',
      'display:inline-flex',
      'align-items:center',
      'justify-content:center',
      'padding:0',
      'border:none',
      'border-radius:50%',
      'background:radial-gradient(circle, rgba(252,233,241,.6) 0%, rgba(252,233,241,0) 72%), conic-gradient(from 131deg, rgba(245,245,245,.6) 0deg, rgba(221,34,118,.1) 182.783deg, rgba(245,245,245,.6) 360deg), #ffffff',
      'color:#dd2276',
      'box-shadow:0 2px 4px rgba(22,22,22,.16)',
      'cursor:pointer',
      '-webkit-tap-highlight-color:transparent',
      'opacity:0',
      'transform:translate(-50%, 12px)',
      'pointer-events:none',
      'transition:opacity .2s ease, transform .2s ease',
    ].join(';');
    document.body.appendChild(btn);

    btn.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });

    // The end of the first page of products (the 28th tile). Null on short
    // collections that never trigger infinite scroll.
    function firstPageAnchor() {
      var grid =
        document.querySelector('#gf-products') ||
        document.querySelector('#product-grid');
      if (!grid || grid.children.length < FIRST_PAGE) return null;
      return grid.children[FIRST_PAGE - 1];
    }

    var shown = false;
    function setShown(s) {
      if (s === shown) return;
      shown = s;
      btn.style.opacity = s ? '1' : '0';
      btn.style.transform = s ? 'translate(-50%, 0)' : 'translate(-50%, 12px)';
      btn.style.pointerEvents = s ? 'auto' : 'none';
    }

    function update() {
      var anchor = firstPageAnchor();
      if (!anchor) return setShown(false);
      // Past the first page once the 28th tile has scrolled above the viewport.
      var pastFirstPage = anchor.getBoundingClientRect().bottom < 0;
      // Hand off to the inline button as soon as it scrolls into view.
      var inline = document.querySelector('.cl-back-to-top-wrap');
      var inlineInView = inline && inline.getBoundingClientRect().top < window.innerHeight;
      setShown(pastFirstPage && !inlineInView);
    }

    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update, { passive: true });
    update();
  });
})();
